// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"79ca67d7","917":"d2010564"}[chunkId] + ".chunk.js";
};